import { FieldState, FormApi } from 'final-form';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: ['form', 'label', 'name'],
    template: require('./field.html'),
})
export class Field extends Vue {
    public form: FormApi;
    public name: string;
    public bootstrapState: boolean | null = null;

    public fieldState: FieldState = null as any;

    private unsubscribe;

    public created() {
        this.unsubscribe = this.form.registerField(
            this.name,
            state => {
                this.fieldState = state;
                this.bootstrapState = state.touched && !state.valid ? false : null;
            },
            {
                active: true,
                dirty: true,
                dirtySinceLastSubmit: true,
                error: true,
                initial: true,
                invalid: true,
                pristine: true,
                submitError: true,
                submitFailed: true,
                submitSucceeded: true,
                touched: true,
                valid: true,
                value: true,
                visited: true,
            },
        );
    }

    public beforeDestroy() {
        requestAnimationFrame(() => this.unsubscribe());
    }
}
